import React from 'react';
import './Homelab.css';

function Homelab () {
  return (
    <div>
      <div className="homelab-container">
        <h1>My Homelab Build</h1>
        <p>This is my current project and my first real go at creating a blog. This page will be my entire process on creating my homelab. I will be updating as I go along.</p>
        <p>My goal for this homelab will be to self host a media server for my movies and TV shows, but I also want to learn more about networking. In my current job, I dabble in networking and this is a great way to learn more. I plan to use Jellyfin for the media server, and then I want to eventually implement Pihole to have network wide ad blocking. That is my basic plan, but will be adding more as I gain experience.</p>
      </div>

      <div className='date-entry'>
        <h3>December 22nd, 2025</h3>
        <p>Today I started really planning my homelab build. I watched a few videos and took some notes. The first step in building my setup, is to make a list of equipment, so I'll make a list below. I'm hoping I can get a good ThinkCentre or adjacent mini PC on Facebook Marketplace instead of buying new. The rest will more than likely be bought at MicroCenter. Excited for that trip. I was wanting to get my rack from deskpi.com but they wanted $132 for shipping alone. Yeah no thanks. Anyway, here's my list:</p>
        <ul>
          <li>ThinkCentre or adjacent mini PC</li>
          <li>Tp-Link AX1500 Wifi Router</li>
          <li>Netgear GS108 8 Port Ethernet Switch</li>
          <li>Raspberry Pi 4</li>
          <li>3-4 TB USB Hard Drive</li>
          <li>Short ethernet cables</li>
          <li>7 inch LCD screen for Raspberry Pi</li>
        </ul>
        <p>Please note that this is subject to change as I learn. I may not need everything in this list. This is just me brainstorming.</p>
      </div>
    </div>

    
  );
}

export default Homelab;